import axios from "axios";

// Vistas manuales (APIView): sin slash final.
export default {
  estado() {
    return axios.get("/asistente/estado");
  },
  chat(mensaje, conversacionId = null, contexto = "empresa") {
    return axios.post("/asistente/chat", { mensaje, conversacion_id: conversacionId, contexto });
  },
  conversaciones() {
    return axios.get("/asistente/conversaciones");
  },
  conversacion(id) {
    return axios.get(`/asistente/conversaciones/${id}`);
  },
  borrarConversacion(id) {
    return axios.delete(`/asistente/conversaciones/${id}`);
  },
  aceptarTerminos() {
    return axios.post("/asistente/terminos/aceptar");
  },
  sugerir(texto, conversacionId = null) {
    return axios.post("/asistente/sugerencias", { texto, conversacion_id: conversacionId });
  },
  aprenderCompra(proveedorId, asociaciones) {
    return axios.post("/asistente/compras/aprender", { proveedor_id: proveedorId, asociaciones });
  },
  leerPresupuesto(archivo) {
    const form = new FormData();
    form.append("archivo", archivo);
    return axios.post("/asistente/presupuestos/leer", form, { headers: { "Content-Type": "multipart/form-data" } });
  },
  feedback(mensajeId, feedback, comentario = "") {
    return axios.post(`/asistente/mensajes/${mensajeId}/feedback`, { feedback, comentario });
  },
};
